<template>
    <span>
      <template v-if="url">
        <!-- {{url}} -->
        <!-- <video class="video" :id="idElemento()" width="100%" height="auto" controls></video> -->
        <video class="video" :id="idElemento()" width="100%" height="auto" ref="videoPlayer" autoplay controls playsinline muted></video>
      </template>
      <template v-else>
        <div class="d-flex flex-column justify-center align-center" style="width: 100%; height: 250px; background: #F2F2F2;">
          <v-icon x-large>mdi-video-off</v-icon>Fuente de vídeo no especificada
        </div>
      </template>
    </span>
</template>

<script>
import { uniqueId } from "@/util";

export default {
  props: {
    // La URL debe ser algo como: http://89.0.4.230:8889/cam1/whep
    url: {
      type: String,
      required: true,
      default: ""
    }
  },
  data() {
    return {
      peerConnection: null,
    };
  },
  mounted() {
    if (!this.url) return;

    this.initWebRTC();
  },
  beforeDestroy() {
    this.stopStream();
  },
  methods: {
    idElemento() {
      if (!this.uid)
        this.uid = uniqueId();
      return 'Video_' + this.uid;
    },
    async initWebRTC() {
      try {
        // 1. Crear la conexión Peer
        this.peerConnection = new RTCPeerConnection();

        // 2. Escuchar cuando llegue el flujo de video
        this.peerConnection.ontrack = (event) => {
          if (this.$refs.videoPlayer) {
            this.$refs.videoPlayer.srcObject = event.streams[0];
          }
        };

        // 3. Configurar para recibir (no enviar)
        this.peerConnection.addTransceiver('video', { direction: 'recvonly' });
        this.peerConnection.addTransceiver('audio', { direction: 'recvonly' });

        // 4. Crear oferta SDP
        const offer = await this.peerConnection.createOffer();
        await this.peerConnection.setLocalDescription(offer);

        // 5. Negociar con MediaMTX vía WHEP
        const response = await fetch(this.url, {
          method: 'POST',
          body: this.peerConnection.localDescription.sdp,
          headers: {
            'Content-Type': 'application/sdp'
          }
        });

        if (!response.ok) throw new Error('Fallo en la respuesta de MediaMTX');

        // 6. Aplicar la respuesta (Answer) del servidor
        const answerSdp = await response.text();
        await this.peerConnection.setRemoteDescription(
          new RTCSessionDescription({ type: 'answer', sdp: answerSdp })
        );

      } catch (error) {
        console.error('Error inicializando WebRTC:', error);
      }
    },
    stopStream() {
      if (this.peerConnection) {
        this.peerConnection.close();
        this.peerConnection = null;
      }
    }
  }
};
</script>

<style>
.video {
  background: black url('~@/assets/loader.gif') center no-repeat;
  margin: 0px 0px -7px 0px;
}
</style>